// Auto-generated normalizer for table: Cursos
export function cursosNormalize(row) {
  return {
    idCurso: row.idCurso ?? row.IdCurso ?? row['IdCurso'] ?? 0,
    idInstructor: row.idInstructor ?? row.IdInstructor ?? row['IdInstructor'] ?? 0,
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    idNivel: row.idNivel ?? row.IdNivel ?? row['IdNivel'] ?? 0,
    duracion: row.duracion ?? row.Duracion ?? row['Duracion'] ?? 0,
    idContenido: row.idContenido ?? row.IdContenido ?? row['IdContenido'] ?? 0,
    uRLRutaImagen: row.uRLRutaImagen ?? row.URLRutaImagen ?? row['urlRutaImagen'] ?? '',
    idTipoHabilidad: row.idTipoHabilidad ?? row.IdTipoHabilidad ?? row['IdTipoHabilidad'] ?? null,
    terminado: row.terminado ?? row.Terminado ?? row['Terminado'] ?? false,
    autoAsignable: row.autoAsignable ?? row.AutoAsignable ?? row['AutoAsignable'] ?? false,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    tieneCertificado: row.tieneCertificado ?? row.TieneCertificado ?? row['TieneCertificado'] ?? false,
  };
}
